import { lazy, Suspense, useCallback, useRef, useState } from "react";
import { OfferDialog } from "./OffersSection";

const Paw3D = lazy(() => import("./three/Paw3D"));
const COUNT = 26;

const track = (name, label) => window.gtag?.("event", name, { event_category: "engagement", event_label: label });

function makeBurst(x, y) {
  return Array.from({ length: COUNT }, (_, i) => {
    const angle = (i / COUNT) * Math.PI * 2 + Math.random() * 0.4;
    const dist = 120 + Math.random() * 180;
    return {
      id: `${Date.now()}-${i}`,
      x, y,
      dx: Math.cos(angle) * dist,
      dy: Math.sin(angle) * dist - 60,
      rot: (Math.random() - 0.5) * 540,
      size: 20 + Math.random() * 22,
      delay: Math.random() * 0.08,
      white: i % 3 === 0,
    };
  });
}

export default function PawSurprise({ className = "" }) {
  const wrapRef = useRef(null);
  const [bits, setBits] = useState([]);
  const [offer, setOffer] = useState(false);

  const onTap = useCallback((e) => {
    const r = wrapRef.current.getBoundingClientRect();
    const burst = makeBurst(e.clientX - r.left, e.clientY - r.top);
    setBits((b) => [...b, ...burst]);
    setTimeout(() => setBits((b) => b.filter((p) => !burst.includes(p))), 1400);
    setTimeout(() => setOffer(true), 900);
    track("paw_tap", "hero_paw");
  }, []);

  return (
    <div ref={wrapRef} className="relative">
      <Suspense fallback={<img src="/brand/paw.png" alt="" className={`relative w-full object-contain p-16 animate-floatY ${className}`} />}>
        <Paw3D className={className} onTap={onTap} />
      </Suspense>
      <div className="pointer-events-none absolute inset-0 z-10" aria-hidden="true">
        {bits.map((p) => (
          <img
            key={p.id}
            src="/brand/paw.png"
            alt=""
            className={`paw-bit absolute ${p.white ? "brightness-0 invert" : ""}`}
            style={{ left: p.x, top: p.y, width: p.size, height: p.size, "--dx": `${p.dx}px`, "--dy": `${p.dy}px`, "--rot": `${p.rot}deg`, animationDelay: `${p.delay}s` }}
          />
        ))}
      </div>
      <OfferDialog open={offer} onOpenChange={setOffer} defaultOffer="oil-massage" source="paw" />
    </div>
  );
}
